import SIMPLE_WORKBOOK_BUNDLE_36 from './SIMPLE_WORKBOOK_BUNDLE_36'
import SIMPLE_WORKBOOK_BUNDLE_48 from './SIMPLE_WORKBOOK_BUNDLE_48'
import SIMPLE_WORKBOOK_BUNDLE_45 from './SIMPLE_WORKBOOK_BUNDLE_45'
import SIMPLE_WORKBOOK_BUNDLE_19_99 from './SIMPLE_WORKBOOK_BUNDLE_19_99'
import SIMPLE_WORKBOOK_BUNDLE_29_99 from './SIMPLE_WORKBOOK_BUNDLE_29_99'
import SIMPLE_WORKBOOK_BUNDLE_35 from './SIMPLE_WORKBOOK_BUNDLE_35'
import SIMPLE_WORKBOOK_BUNDLE_35_V2 from './SIMPLE_WORKBOOK_BUNDLE_35_V2'
import SIMPLE_WORKBOOK_BUNDLE_26 from './SIMPLE_WORKBOOK_BUNDLE_26'

export default {
	SIMPLE_WORKBOOK_BUNDLE_36,
	SIMPLE_WORKBOOK_BUNDLE_48,
	SIMPLE_WORKBOOK_BUNDLE_45,
	SIMPLE_WORKBOOK_BUNDLE_19_99,
	SIMPLE_WORKBOOK_BUNDLE_29_99,
	SIMPLE_WORKBOOK_BUNDLE_35,
	SIMPLE_WORKBOOK_BUNDLE_35_V2,
	SIMPLE_WORKBOOK_BUNDLE_26,
}
